import React, { useEffect, useRef } from 'react';

import { ReactComponent as MarkerStandardIcon } from './assets/icons/marker-standard.svg';
import { ReactComponent as MarkerPrivateIcon } from './assets/icons/marker-standard-private.svg';

import { ReactComponent as MarkerCargoIcon } from './assets/icons/marker-cargo.svg';
import { ReactComponent as ActiveLocationCargoIcon } from './assets/icons/active-location-cargo.svg';
import { ReactComponent as UnavailableLocationStandardIcon } from './assets/icons/unavailable-location-standard.svg';
import { ReactComponent as UnavailableLocationCargoIcon } from './assets/icons/unavailable-location-cargo.svg';
import './CustomMarker.css'

import { ReactComponent as ErrorBadgeIcon } from './assets/icons/error-badge.svg';
import { LocationData } from './LocationTypes';


const SelectedLocationIcon = (isInMaintenance: boolean, availableStandardSpots: number) => {
  return isInMaintenance ? (

    <div>
      <UnavailableLocationStandardIcon
        width={80}
        height={80}
        fill="black"
      />
      <ErrorBadgeIcon
        width={22}
        height={22}
        className='errorBadgeActive'
      />
    </div>
  ) : (
    <div>

      <MarkerStandardIcon
        width={80}
        height={80}
        fill="black"
      />
      <div className='markerInfoActive'>
        <p className='infoText'>{availableStandardSpots}</p>
      </div>
    </div>
  )
}

const LocationIcon = (isInMaintenance: boolean, isPrivate: boolean, availableStandardSpots: number) => {
  return <div>
    {isPrivate ?
      <MarkerPrivateIcon
        width={60}
        height={60}
        fill="black"
        className='markerIcon'
      /> :
      <MarkerStandardIcon
        width={60}
        height={60}
        fill="black"
        className='markerIcon'
      />
    }
    {isInMaintenance ? (
      <ErrorBadgeIcon
        width={22}
        height={22}
        className='errorBadge'
      />
    ) : (
      <div className='markerInfoActive'>
        <p className='infoText'>{availableStandardSpots}</p>
      </div>
    )}
  </div>
}

const getTotalAvailableSpots = (location: LocationData) : number => {
  return location.availableStandardSpots + location.availableCargoSpots + location.availableFamilySpots + location.availableLongtailSpots;
}

const CustomMarker = React.memo(
  ({ location, highlight, onHover }: { location: LocationData, highlight: boolean, onHover: () => void }) => {

    if (location.isCluster) {
      return (
        <>
        <MarkerStandardIcon
          width={60}
          height={60}
          fill="black"
          className='markerIcon'
        />
        <div className='markerInfoCluster'>
          <p className='infoText'>{getTotalAvailableSpots(location)}</p>
        </div>
      </>
      );
    }

    return (
      <>
        {(location.isInMaintenance ? (
          <>
            <UnavailableLocationCargoIcon
              width={80}
              height={80}
              fill="black"
            />
            <ErrorBadgeIcon
              width={22}
              height={22}
              className='errorBadgeActive'
            />
          </>
        ) : (
          <>
            <MarkerStandardIcon
              width={60}
              height={60}
              fill="black"
              className='markerIcon'
            />
            <div className='markerInfo'>
              <p className='infoText'>{getTotalAvailableSpots(location)}</p>
            </div>
          </>
        )
        )}
      </>
    );

  },
);

export default CustomMarker;
